export const endpoints = {
  login: 'api/v2/auth/admin/login',
  logout: 'api/v2/auth/logout',

  // ── Users ──────────────────────────────────────────────
  getAllUsers: 'api/v2/users/admin/get-all-users',
  getSpecificUser: 'api/v2/users/get-specific-user/',
  getOwnProfile: 'api/v2/users/get-user-profile/',
  adminUpdateUserProfile: 'api/v2/users/admin-update-user-profile',
  adminDeleteUser: 'api/v2/users/admin/admin-delete-user',
  getUserActivities: 'api/v2/users/get-user-activities',
  getUserBooks: 'api/v2/users/my-books-created/',
  scheduleUserDeletion: 'api/v2/users/user-delete-profile/',
  reactivateAccount: 'api/v2/users/user/reactivate-account/',
  getDeletionStatus: 'api/v2/users/user/deletion-status/',

  // ── Books ───────────────────────────────────────────────
  getAllBooks: 'api/v2/books/all-books-dashboard/',
  getSpecificBook: 'api/v2/books/get-specific-book/',
  addBook: 'api/v2/books/add-book/',
  updateBook: 'api/v2/books/update-book/',
  updateBookStatus: 'api/v2/books/change-book-status/',
  deleteBook: 'api/v2/books/delete-book/',
  userDeleteBook: 'api/v2/books/user-delete-has-book/',
  userUpdateBook: 'api/v2/books/user-update-has-book/',

  // ── Categories ──────────────────────────────────────────
  getAllCategories: 'api/v2/categories/get-all-categories',
  getSpecificCategory: 'api/v2/categories/get-specific-category',
  addCategory: 'api/v2/categories/add-category',
  updateCategory: 'api/v2/categories/update-category',
  deleteCategory: 'api/v2/categories/delete-category',

  // ── Subcategories ───────────────────────────────────────
  getAllSubCategory: 'api/v2/subcategories/get-all-subcategories/',
  getSpecificSubcategory: 'api/v2/subcategories/get-specific-subcategory',
  addSubcategory: 'api/v2/subcategories/add-subcategory',
  updateSubcategory: 'api/v2/subcategories/update-subcategory',
  deleteSubcategory: 'api/v2/subcategories/delete-subcategory',

  // ── Chat ────────────────────────────────────────────────
  getAllChatsForUser: 'api/v2/chats/get-all-chats-for-user',
  getUserChats: 'api/v2/chats/get-all-messages-for-specific-chat',
  sendMessage: 'api/v2/chats/send-message/',
  getChatMatching: 'api/v2/chats/get-chat-matching',
  deleteChat: 'api/v2/chats/delete-chat/',

  // ── Tickets ─────────────────────────────────────────────
  getAllTickets: 'api/v2/tickets/get-all-tickets/',
  getSpecificTicket: 'api/v2/tickets/get-specific-ticket/',
  createTicket: 'api/v2/tickets/create-ticket/',
  updateSpecificTicket: 'api/v2/tickets/update-ticket/',
  deleteTicket: 'api/v2/tickets/delete-ticket/',
  getUserTickets: 'api/v2/tickets/all-user-tickets/',

  // ── Notifications ───────────────────────────────────────
  getAdminNotifications: 'api/v2/notifications/user-notifications',
  getUnreadCount: 'api/v2/notifications/unread-count',
  markAsRead: 'api/v2/notifications/mark-as-read/',
  markAllAsRead: 'api/v2/notifications/mark-all-as-read',
  deleteNotification: 'api/v2/notifications/delete-notification',
  deleteAllReadNotifications: 'api/v2/notifications/delete-all-read',
  adminAssignNotification: 'api/v2/notifications/admin-assign-notification',
  testSendPush: 'api/v2/notifications/test-send-push',
  adminTargetedNotification: 'api/v2/notifications/admin-targeted-notification',
  registerFcmToken: 'api/v2/notifications/register-fcm-token',
  registerGuestFcmToken: 'api/v2/notifications/register-guest-fcm-token',
  removeFcmToken: 'api/v2/notifications/remove-fcm-token',

  // ── Badges ──────────────────────────────────────────────
  assignBadge: 'api/v2/badges/assign',
  getMyBadges: 'api/v2/badges/get-my-badges',

  // ── Charts — Users ──────────────────────────────────────
  logs: 'api/v2/charts/logs',
  getMalesAndFemalesUsersCount: 'api/v2/charts/get-male-or-female-users',
  getAgeChart: 'api/v2/charts/age',
  getMostActiveUsers: 'api/v2/charts/get-most-active-users',
  trackVisit: 'api/v2/charts/track-visit',

  // ── Charts — Books ──────────────────────────────────────
  getBooksPerCategory: 'api/v2/charts/books-per-category',
  getBooksPerMonth: 'api/v2/charts/books',
  getBooksStatusDistribution: 'api/v2/charts/get-books-status-distribution',
  getBooksByEducationType: 'api/v2/charts/get-books-by-education-type',
  getBooksByCity: 'api/v2/charts/get-books-by-city',
  getBooksByEducationTerm: 'api/v2/charts/get-books-by-education-term',

  // ── Charts — Tickets ────────────────────────────────────
  getTicketPerMonth: 'api/v2/charts/get-tickets-per-month',
  getTicketByType: 'api/v2/charts/get-tickets-by-type',
  getTicketByStatus: 'api/v2/charts/get-tickets-by-status',
  getTicketsByCommonReason: 'api/v2/charts/get-tickets-by-common-reasons',
  getTicketsWithLinkedEntities: 'api/v2/charts/get-tickets-with-linked-entities',
};
